import '../fake-db'
import React from 'react'
import { Store } from './redux/Store'
import { Provider } from 'react-redux'
import { Navigate, Route, Routes, useRoutes } from 'react-router-dom'
import { AllPages } from './routes/routes'
import { SnackbarProvider } from 'notistack'
import { AuthProvider } from './contexts/JWTAuthContext'
import Notifier from './utils/Notifier'
import MatxTheme from './components/MatxTheme/MatxTheme'
import { SettingsProvider } from './contexts/SettingsContext'

const App = () => {
	const all_pages = useRoutes(AllPages())

	return (
		<Provider store={Store}>
			<SettingsProvider>
				<MatxTheme>
					<SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }} dense disableWindowBlurListener autoHideDuration={4000}>
						<Notifier />
						<AuthProvider>
							{all_pages}
							<Routes>
								<Route path='/' element={<Navigate to='/dashboard' />} />
							</Routes>
						</AuthProvider>
					</SnackbarProvider>
				</MatxTheme>
			</SettingsProvider>
		</Provider>
	)
}

export default App
